<lm-card [elevated]="true" [overflow]="false">
    <lm-card-header [classList]="'flex h-[50px] items-center w-full'">
        <div class="flex justify-between h-[32px] w-full">
            <lm-checkbox *ngIf="check && !noaction && status == 9" [noGutters]="true" [value]="idChecked.includes(item.orderId)" [size]="'large'" (change)="onSelectedEvent.emit(item.orderId)"></lm-checkbox>
            <div class="flex items-center">
                <span *ngIf="!nostatus" class="rounded-full w-[30px] h-[30px]" [ngClass]="{'bg-[#BDE5E2]': status == 1, 'bg-[#EBA41E]': status == 2, 'bg-[#FA7A6A]': status == 3}"></span>
                <span class="font-medium text-base" [ngClass]="{'pl-4': !nostatus}">{{ item.orderId }}</span>
            </div>
            <div class="flex items-center" *ngIf="alert">
                <img [src]="'assets/icons/Icon-Alert.svg'" class="h-[19px]" />
            </div>
            <div class="flex items-center">
                
                <span class="font-medium text-base" [ngClass]="{'pr-4': !noaction, 'text-[#EC3B2C]': alert}">{{ item.data ? item.data : '11/09/2024' }}</span>
                <!-- <lm-icon-image *ngIf="!check && !noaction" (click)="onOptionEvent.emit(item.productId)" [src]="'assets/icons/Icon-Options.svg'"></lm-icon-image> -->
                <lm-dropdown *ngIf="!check && !noaction">
                    <div lmDropdownToggle>
                      <lm-icon-image [src]="'assets/icons/Icon-Options.svg'"></lm-icon-image>
                    </div>
                    <ul lmDropdownContainer class="dropdown right-0">
                      <li (click)="onOptionReportEvent.emit(item.productId)"class="uppercase">{{t('orders.reportProblem')}}</li>
                      <li (click)="onOptionNoStockEvent.emit(item.productId)"class="uppercase">{{t('orders.noStock')}}</li>
                    </ul>
                  </lm-dropdown>
                <lm-checkbox *ngIf="check && !noaction" [noGutters]="true" [value]="idChecked.includes(item.orderId)" [size]="'large'" (change)="onSelectedEvent.emit(item.orderId)"></lm-checkbox>
            </div>
        </div>
    </lm-card-header>
    <lm-card-content>
        <div class="flex">
            <div class="max-h-[160px] w-1/3">
                <img class="h-full w-auto" [src]="item?.images?.length > 0 ? item.images[0] :'https://media.giglio.com/image/upload/v1663662921/assets/images-app/item-placeholder/single-no-image.png'" />
            </div>
            <div class="text-xs font-normal flex px-1 gap-y-1.5 flex-col">
                <div *ngIf="type != 2">
                    <span class="uppercase">{{t('orders.partner')}}: </span>
                    <span class="font-bold">{{ item.brand.label }}</span>
                </div>
                <div>
                    <span class="uppercase">{{t('orders.code')}}: </span>
                    <span class="font-bold">{{ item.code }}</span>
                </div>
                <div>
                    <span class="uppercase">{{t('orders.sku')}}: </span>
                    <span class="font-medium">{{ item.sku }}</span>
                </div>
                <div>
                    <span class="uppercase">{{t('orders.line')}}: </span>
                    <span class="font-medium">{{ item.brand.label }}</span>
                </div>
                <div>
                    <span class="uppercase">{{t('orders.size')}}: </span>
                    <span class="font-medium">{{ item.category.category.label }}</span>
                </div>
                <div>
                    <span class="uppercase">{{t('orders.code')}}: </span>
                    <span class="font-medium">{{ item.sizes[0].label }}</span>
                </div>
                <div>
                    <span class="uppercase">{{t('orders.season')}}: </span>
                    <span class="font-medium">{{ item.season }}</span>
                </div>
                <div>
                    <span class="uppercase">{{t('orders.barcode')}}: </span>
                    <span class="font-bold">{{ item.barcode }}</span>
                </div>
                <div *ngIf="type == 2">
                    <span class="uppercase">{{t('orders.warehouse')}}: </span>
                    <span class="font-medium">{{ item.warehouse }}</span>
                </div>
            </div>
        </div>
    </lm-card-content>
    <lm-card-footer [classList]="'flex h-[50px] items-center w-full'">
        <div class="flex justify-between items-center w-full">
            <div class="text-xs font-normal">{{t('orders.qta')}}:
                <span class="font-medium">{{ item.qta }}</span>
            </div>
            <lm-button *ngIf="type === 1" [color]="disabled ? 'primary' : 'secondary'" [disabled]="disabled" (click)="onClickEvent.emit({id:item.orderId,status:'confirm'})"><span class="flex items-center gap-x-1"><img [src]="'assets/icons/Icon-Check.svg'" class="h-[16px]" /> {{t('orders.confirm')}}</span></lm-button>
            <lm-button *ngIf="type === 2" [color]="disabled ? 'primary' : 'secondary'" [disabled]="disabled" (click)="onClickEvent.emit({id:item.orderId,status:'move'})"><span class="flex items-center gap-x-1">{{t('orders.move')}} <img [src]="'assets/icons/Icon-Arrow-2-Right.svg'" class="h-[12px]" /></span></lm-button>
            <lm-button *ngIf="type === 3" [color]="disabled ? 'primary' : 'secondary'" [disabled]="disabled" (click)="onClickEvent.emit({id:item.orderId,status:'problem'})">{{t('orders.reportProblem')}}</lm-button>
            <span class="!mb-0 !h-[27px] !text-xs" *ngIf="type === 4" lmTag color="green">{{t('orders.reportCompleted')}}</span>
            <span class="!mb-0 !h-[27px] !text-xs" *ngIf="type === 5" lmTag color="orange">{{t('orders.waiting')}}</span>
            <lm-button *ngIf="type === 6" [color]="'secondary'" [classes]="'border-0'" [disabled]="disabled" (click)="onClickEvent.emit({id:item.orderId,status:'answer'})"><span class="flex items-center gap-x-2">{{t('orders.seeAnswer')}} <img [src]="'assets/icons/Icon-Answer.svg'" class="w-[20px]" /></span></lm-button>
            <lm-button *ngIf="type === 7" [color]="disabled ? 'primary' : 'secondary'" [disabled]="disabled" (click)="onClickEvent.emit({id:item.orderId,status:'resolv'})">{{t('orders.resolve')}}</lm-button>
        </div>
    </lm-card-footer>
</lm-card>
